/**
 * @file
 * Pin script.
 */

(function pinScript($, Drupal) {
  'use strict';

  Drupal.behaviors.pinImageFlipToggle = {
    attach: function (context) {
      // This is the placeholder & front element on page load.
      var $pinImageFlipper = $('.js-pin-image-flipper', context);

      // Flip the placeholder to reveal the image on click.
      $pinImageFlipper.each(function () {
        $(this).click(function () {
          var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
          if (isIE11) {
            // We have to use 3 .parent() functions instead of .closest() because of IE11.
            $(this)
              .parent()
              .parent()
              .parent()
              .toggleClass('pin__image-wrap--flip');
          }
          else {
            $(this).closest('.js-pin-image-wrap')
              .toggleClass('pin__image-wrap--flip');
          }
        });
      });
    }
  };
}(jQuery, Drupal));
